module.exports = __webpack_public_path__ + "static/media/ext14.8b0b49fc.jpg";